import { Layout } from 'Components/Layout/Layout';
import { OrdersList } from 'Containers/Orders/OrdersList/OrdersList';

export const OrdersListPage = () => {
  return (
    <Layout>
      <OrdersList />
    </Layout>
  );
};
